import { getPayloadToSign } from '@lfg/core/lib';
import { keccak256, toBytes } from 'viem';
import { Config } from 'wagmi';
import { signMessage } from 'wagmi/actions';

type Signer = {
  address: `0x${string}`;
  chainId: number;
  config: Config;
};

let _signer: Signer | null = null;

export function initWeb3Signer(s: Signer) {
  _signer = s;
}

export function getWeb3Signer(): Signer | null {
  return _signer;
}

export function shaBody(body: unknown) {
  const str = body ? JSON.stringify(body) : '';
  return keccak256(toBytes(str));
}

export async function signRequest(body: unknown, overrides?: Partial<Signer>) {
  const signer = overrides ?? _signer;
  if (!signer || !signer.config) throw new Error('Web3 signer not initialized');

  const now = new Date().getTime();

  const message = {
    body: body || {},
    issuedAt: now,
  };
  const payloadToSign = getPayloadToSign(message);
  const signature = await signMessage(signer.config, { message: payloadToSign });

  return { signature, message, issuedAt: now };
}
